import { ocapiClient } from '../../../../api-clients/ocapi/client';
import { createOrGetFetchedState } from '../../../../utils/fetched-data/create-or-get-fetched-state';
import { getCacheDuration } from '../../../../utils/get-cache-duration';
import { loadDataFromApi } from '../../../../utils/load-data-from-api';
import { browsingDomainStore } from '../../store';
import { assignFilmRelatedData } from './utils/assign-related-data';
export const loadFilmById = async (filmId, reloadCachedData = false) => {
    const state = createOrGetFetchedState(browsingDomainStore.data.filmsById, filmId);
    await loadDataFromApi({
        api: () => ocapiClient.instance.v1.browsing.masterData.films.getById(filmId),
        state,
        cacheDuration: getCacheDuration('films'),
        onSuccess,
        reloadCachedData
    });
};
const onSuccess = (response, cacheDuration) => {
    const { film, relatedData } = response;
    assignFilmRelatedData(relatedData, cacheDuration);
    return film;
};
